import React from "react";
import styled from "styled-components";
import "./styles.css";

// Incase the "Due Today" text wraps for some reason.
// Note: In IE, even if the nowrap is applied, the Charges Summary width
// won't adjust to fit the content. "Due Today" text just overflows.
const DueTodayText = styled.td`
  white-space: nowrap;
`;

export default ({ downPayment }) => (
  <div>
    <table class="msg-downpayment">
      <tbody>
        <tr>
          <DueTodayText>Due Today:</DueTodayText>
          <td class="right">${downPayment}</td>
        </tr>
      </tbody>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/ChargesSummary/DueToday/index.js